import React, { createContext, useContext, useState } from 'react';
import useLocalCart from '../hooks/useLocalCart';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  
  const [cartOpen, setCartOpen] = useState(false);

 const {
  cartData,
  customer,
  coupons,
  shipping,
  shippingOptions,
  shippingLoading,
  shippingError,
  addToCart,
  applyCoupon,
  attachCustomer,
  checkout,
  emptyCart,
  isInCart,
  getItemQuantity,
  getGrossCartTotal,
  getNetCartTotal,
  getSubtotal,
  getTaxAmount,
  getTotalDiscount,
  getTotalItems,
  getShippingCost,
  refreshShippingOptions,
  selectShippingOption,
  clearShippingSelection,
  removeCoupon,
  removeFromCart,
  updateCartItem,
 } = useLocalCart()


  const openCartOverlay = () => {
    setCartOpen(true)
  }

  const closeCartOverlay = () => {
    setCartOpen(false)
  }

  const value = {
    cartData,
    cartOpen,
    customer,
    coupons,
    shipping,
    shippingOptions,
    shippingLoading,
    shippingError,
    addToCart,
    applyCoupon,
    attachCustomer,
    checkout,
    closeCartOverlay,
    emptyCart,
    isInCart,
    getItemQuantity,
    getGrossCartTotal,
    getNetCartTotal,
    getSubtotal,
    getTaxAmount,
    getTotalDiscount,
    getTotalItems,
    getShippingCost,
    refreshShippingOptions,
    selectShippingOption,
    clearShippingSelection,
    openCartOverlay,
    removeCoupon,
    removeFromCart,
    updateCartItem,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart must be used within a CartProvider');
  return context;
};
